import React, { useState } from 'react';
import Sidebar from './Sidebar.js';
import AdminHeader from './Header.js';
import { Card, Row, Col, Container, Button } from 'react-bootstrap';
import Breadcrumb from './Breadcrumb.js';
import industriesData from './data/industries.js';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';

const MappingIndustriesView = () => {

    const navigate = useNavigate();

    return (
        <>
            <AdminHeader />
            <Container className="pt-2">
                <Row>
                    <Col xs={2} className="p-0">
                    </Col>
                    <Col xs={10} className="p-0">
                        <Breadcrumb />
                    </Col>
                </Row>
            </Container>
            <Container fluid>
                <Row>
                    <Col xs={3} className="p-0">
                        <Sidebar />
                    </Col>

                    <Col xs={9} className="p-4">
                        <Card>
                            <Card.Body>
                                <h1 className="mb-3">Industries</h1>
                                <Row className="mb-4">
                                    <Col>
                                        {industriesData.map((industry, index) => (
                                            <Row>
                                                <Col md={12}>
                                                    <p className="form-control-plaintext">{industry.name}</p>
                                                    <Button
                                                        variant="secondary"
                                                        onClick={() => navigate(`/mapping-industry/${industry.code}/subindustries`)}
                                                        >
                                                        Sub Industries
                                                    </Button>
                                                </Col>
                                            </Row>
                                        ))}
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                <Row>
                    <Col className="d-flex justify-content-end gap-2 px-4">
                        <Button variant="secondary" onClick={() => navigate('/mapping-overview')}>
                            Back
                        </Button>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default MappingIndustriesView;
